export function formatCurrency(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === "") return "—";
  const x = typeof n === "number" ? n : Number(n);
  if (!Number.isFinite(x)) return "—";
  return x.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
}
